import { FormikHelpers } from "formik";
import AtmTypeForm from "./AtmTypeForm";
import { useGetAtmType } from "./api/getAtmType";
import { useEditAtmType } from "./api/editAtmType";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditAtmType = ({handleCloseModal, atmTypeId}: EditAtmTypeProps)  => {
  const getAtmTypeQuery = useGetAtmType({atmTypeId: atmTypeId})
  const editAtmTypeMutation = useEditAtmType({data: {}, atmTypeId});

  const handleSubmit = async (values: IPostEditAtmType, { setSubmitting }: FormikHelpers<IPostEditAtmType>): Promise<void> => {
    try {
      await editAtmTypeMutation.mutateAsync({
        data: values,
        atmTypeId: atmTypeId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    }finally{
      setSubmitting(false);
    }
  }

  if (getAtmTypeQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getAtmTypeQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Τύπου.</div>
    )
  }

  return (
    <>
      {!getAtmTypeQuery.isLoading && getAtmTypeQuery.data &&
        <AtmTypeForm initialValues={getAtmTypeQuery.data} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditAtmTypeProps {
  atmTypeId: number;
  handleCloseModal: () => void;
}

export default EditAtmType;